import keyBy from 'lodash/keyBy';

const TeamIds = ['bizly', 'apple'] as const;

export type ETeams = (typeof TeamIds)[number];
// TODO: this is intentional to mimick enums but with better properties and may be fixed by a higher version of eslint 4.29.0

export const ETeams = keyBy(TeamIds) as { [key in ETeams]: key };

const ColorIds = [
    'brand',
    'sidenavColor',
    'sidenavActiveColor',
    'sidenavActiveBackground',

    /* Buttons */
    'primaryAction',
    'primaryActionHover',

    'warningAction',
    'warningActionHover',

    'secondaryTextAction',
    'secondaryTextActionHover',
    'warningTextAction',
    'warningTextActionHover',
    'alertWarning',

    'disabledAction',
    'inactiveAction',
    /* Icons */
    'defaultIconColor',
    'primaryDisplayIcon',
    'invertedDisplayIcon',

    'protipsIcon',
    'protipsBubble',
    'tilePinIcon',

    'amenitiesIconBackground',

    /* Attendee Status */
    'totalAttendee',
    'invitedAttendee',
    'notInvitedAttendee',
    'attendingAttendee',
    'notAttendingAttendee',
    'roomBlocks',
    'totalPrice',

    /* Attendee Status v2 */
    'notAttendingAttendeeV2',
    'attendingAttendeeV2',

    /* Survey Response Status */
    'surveysSentTotal',
    'surveysPending',
    'surveysRespondedTo',

    /* Event Status */
    'uneditedEvent',
    'activeEvent',
    'activeEventHover',
    'completedEvent',
    'completedEventHover',

    /* Dashboard */
    'dashboardCard',
    'dashboardHeader',

    /* Parcel Status */
    'parcelInvite',
    'parcelInviteHover',
    'parcelInviteSent',
    'parcelInviteSentHover',

    'parcelNote',
    'parcelNoteHover',
    'parcelNoteSent',
    'parcelNoteSentHover',

    /* Inquiry Status */
    'submittedInquiryStatus',
    'receivedProposalStatus',
    'cancelledOrRejectedStatus',
    'contractPendingStatus',
    'bookedVenueStatus',
    'queuedVenueStatus',

    /* Collaborators */
    'canViewPillBackground',
    'canViewPillText',
    'canEditPillBackground',

    /* Team Related */
    'homeScreenBanner',
    'bannerLinkText',
    'officePillColor',
    'teamTemplatePill',
    'teamPreferenceNotesHeader',
    'teamPicker',
    'teamPickerText',

    /*
        Venues
    */

    /* Venue Search */
    'venueSearchToken',
    'venueSearchTokenHover',

    /* Venue Map Pins */
    'venuePinOffice',
    'venuePinHighlight',
    'venuePinDining',
    'venuePinHotel',
    'venuePinActivityUnique',
    'venuePinMuseumTheater',
    'venuePinEventMeetingConference',
    'venuePinWorkspace',
    'venuePinSearchLocation',
    'venuePinTesting',

    /* Venue Space OR Listing */
    'featuredVenueOrSpaceName',
    'tagColor',
    'restaurantTagColor',
    'venueListingHeaders',
    'preferenceNotesHighlightedText',
    'displayPricing',

    /* Forms */
    'formLabel',
    'formHeading',
    'optionalSpecifier',

    /* Panes */
    'agendaDayPane',
    'agendaDayPaneText',
    'paneListItemBackground',
    'paneInsideListItemBackground',

    /* snackbars */
    'snackbarSuccess',
    'snackbarError',
    'snackbarInfo',

    /* dropdowns */
    'dropdownCheck',
    'dropdownItem',
    'dropdownItemHover',
    'dropdownDescription',
    'dropdownTokenBackground',
    'dropdownTokenText',

    /* progress bars */
    'progressBarForeground',
    'progressBarBackground',

    /* misc UI */
    'accentedHeadline',
    'highlightedText',

    'softAccentedBackground',
    'softAccentedBackgroundNested',
    'strongAccentedBackground',

    'warningBackground',
    'warningText',

    'bizlyHeadlineDot',

    'placeholderBackground',
    'strongCarouselBackground',
    'strongCarouselText',

    'softBorder',

    'listItemBackground',
    'listItemNestedBackground',

    'imagePlaceholderBackground',
    'imagePlaceholderIcon',

    'containerBackground',
    'fieldBorder',

    /* Event Flow */
    'v3LightGrayBackground',
    'v3DarkGrayBorder',

    /* Graphs */
    'graphFontColorVariant1',
    'graphFontColorVariant2',
    'graphColorVariant1',
    'graphColorVariant2',
    'graphColorVariant3',
    'graphColorVariant4',
    'graphColorVariant5',
    'graphColorVariant6',
    'graphColorVariant7',
    'graphColorVariant8',

    'graphUserTotalColor',
    'graphUserActiveColor',
    'graphUserAcceptedColor',
    'graphUserBookedColor',

    'graphMeetingsCreatedColor',
    'graphMeetingsInquiredColor',
    'graphMeetingsAcceptedColor',
    'graphMeetingsBookedColor',
    'graphMeetingsCancelledColor',

    'graphTotalInquiry',
    'graphTotalContract',

    /* Preference Pill */
    'preferredVenue',
    'preferredRank10',
    'preferredRank20',
    'preferredRank30',
    'preferredRank40',
    'preferredRank50',

    /* neutrals */
    'black',
    'darkestGrey',
    'darkerGrey',
    'grey2',
    'grey3',
    'darkGrey',
    'grey',
    'lightGrey',
    'lighterGrey',

    /* pures */
    'pureWhite',
    'pureBlack',

    /* branding */
    'sidenavForeground',
    'subNavBackground',

    /* theme colors */
    'pink',

    /* Carbon */
    'carbonWhite',
    'carbonGreen',

    /* Misc */
    'blushPink',
    'fuchsiaPink',
    'greyBorder',
    'red',
    'green',

    /* Redesign Palette */
    'aliceBlue',
    'platinum',
    'vividFuchsia',
    'drWhite',
    'coldWind',

    /* Invoice Status */
    'invoicePaid',

    /* Bizly OS Colors - Need to take this out into it's own theme file */
    'bizlyOSPrimary',
    'bizlyOSBorder',
    'bizlyOSYellow',
    'bizlyOSWarning',
    'bizlyOSGray20',

    /* Bizly OS "Claim your venue" modal */
    'bizlyOSClaimPurple',
    'bizlyOSClaimTeal',
    'bizlyOSClaimTint',
    'bizlyOSClaimSubtext',
    'bizlyOSClaimMuted',
    'bizlyOSClaimLine',

    /* Bizly Insights */
    'bizlyInsightsBlue',

    /* Bizly OS Status Chips */
    'lemonChiffon',
    'wizardWhite',
    'aquaSpring',
    'blushMist',
    'minuteMauve',

    /* Bizly V3 UI colors TODO: move these colors to a new theme*/
    'v3Background',
    'v3Background2',
    'v3Background3',
    'v3Border',
    'v3BorderSecondary',
    'v3Dark',
    'v3Red',
    'v3Gray',
    'v3Success',
    'v3Error',
    'v3TextPrimary',
    'v3TextSecondary',
    'v3TextPrimary2',
    'v3TextSecondary2',
    'v3ButtonPrimary',
    'v3Green',
    'v3ButtonBackground',
    'v3CardBorder',
    'v3ChatInboundBubble',
    'v3OutgoingBubble',
    'v3StatusChipGreen',
    'v3ContentText',
    'v3InfoGreen',
    'v3IconMuted',

    /* Venue Type Colors */
    'venueTypeHotelBackground',
    'venueTypeHotelText',
    'venueTypeRestaurantBackground',
    'venueTypeRestaurantText',
    'v3AccentColor',
    'v3ButtonHover',
    'v3ButtonPressed',
    'v3ButtonPressedBorder',

    /* Guestroom Savings */
    'v3SavingsPublicRate',
    'v3SavingsNegotiatedRate',

    /* Events Guest Stat Cards */
    'invitedGuestStatCardBackground',
    'invitedGuestStatCardBorder',
    'declinedGuestStatCardBackground',
    'declinedGuestStatCardBorder',
    'attendingGuestStatCardBackground',
    'attendingGuestStatCardBorder',
    'roomsGuestStatCardBackground',
    'roomsGuestStatCardBorder',
] as const;

export type EColors = (typeof ColorIds)[number];
// TODO: this is intentional to mimick enums but with better properties and may be fixed by a higher version of eslint 4.29.0

export const EColors = keyBy(ColorIds) as { [key in EColors]: key };

const FontIds = ['body', 'heading', 'formLabel', 'formHeading'] as const;

export type EFonts = (typeof FontIds)[number];
// TODO: this is intentional to mimick enums but with better properties and may be fixed by a higher version of eslint 4.29.0

export const EFonts = keyBy(FontIds) as { [key in EFonts]: key };
